import React from 'react'
import { connect } from 'react-redux'
import * as actions from '../actions'
import { AppState } from '../reducers'

type NavBtnProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>

const NavBtn = ({ navType, onClick }: NavBtnProps) => {
    return (
        <button id="kr-btn" onClick={onClick}>
            <div id="kr-checkControl">
                <div style={navType === "click" ? { background: "#fdbe12" } : { background: "white" }}></div>
            </div>
            <div>Zmiana nawigacji</div>
        </button>
    )
}

const mapStateToProps = (state: AppState) => ({
    navType: state.navType
})

const mapDispatchToProps = dispatch => ({
    onClick: () => {
        dispatch(actions.toggleNav())
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(NavBtn)
